/*
 * @Author: Tahiti
 * @Date: 2025-10-22 14:12:49
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-10-22 14:14:34
 * @Description:
 * @FilePath: /weryai-web/api/login.ts
 */
import { http } from '~/utils/request'

/**
 * @description: check if email is already registered
 * @param {any} data
 * @return {*}
 */
export const checkEmailStatusApi = (query: Record<string, unknown>) => {
    return http.get('/api/v1/auth/user/exist', {
        params: query,
    })
}
/**
 * @description: user login, register
 * @param {any} data
 * @return {*}
 */
export const loginApi = (data: Record<string, unknown>) => {
    return http.post('/api/v1/login', data, { silentError: true })
}

/**
 * @description: email register
 * @param {any} data
 * @return {*}
 */
export const getVerifyCodeApi = (data: Record<string, unknown>) => {
    return http.post('/api/v1/email/ticket', data)
}

/**
 * @description: send phone verification code for login
 * @param {any} data
 * @return {*}
 */
export const getPhoneVerifyCodeApi = (data: Record<string, unknown>) => {
    return http.post('/api/v1/phone/ticket', data)
}

/**
 * @description: reset password
 * @param {any} data
 * @return {*}
 */
export const resetPasswordApi = (data: Record<string, unknown>) => {
    return http.post('/api/v1/forgot/pwd', data)
}

/**
 * @description: check if email verify code is valid
 * @param {any} data
 * @return {*}
 */
export const checkEmailVerifyCodeStatusApi = (
    data: Record<string, unknown>
) => {
    return http.post('/api/v1/email/ticket/verify', data)
}
